import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { DeliveryZone, OCC_ENDPOINTS, OccDeliveryZonesResponse } from '@delivery/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccDeliveryZonesService {
  constructor(
    private occEndpointsService: OccEndpointsService,
    private http: HttpClient,
  ) {}

  getDeliveryZones(): Observable<DeliveryZone[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.deliveryPolygons);

    return this.http
      .get<OccDeliveryZonesResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.deliveryPolygons),
      })
      .pipe(map((response: OccDeliveryZonesResponse) => response.data.items));
  }
}
